import { bindUrl, request } from "./request";

/**
 * 余额查询
 */
export function getRemain(queryParams) {
  return request({
    url: bindUrl("/oil/app/client/withdraw/remain", {}),
    method: "POST",
    data: queryParams
  });
}

/**
 * 余额提现验证码发送
 */
export function getCode(queryParams) {
  return request({
    url: bindUrl("/oil/app/client/withdraw/codeFetch", {}),
    method: "POST",
    data: queryParams
  });
}
/**
 * 余额提现确认
 */
export function withdrawConfirm(queryParams) {
  return request({
    url: bindUrl("/oil/app/client/withdraw/confirm", {}),
    method: "POST",
    data: queryParams
  });
}

/**
 * 余额提现确认
 */
export function withdrawStatus(queryParams) {
  return request({
    url: bindUrl("/oil/app/client/withdraw/status", {}),
    method: "GET",
    params: queryParams
  });
}
